/**
 * inputAutocompleteDirective
 *
 * TODO: Revisit when md-autocomplete bugs have been fixed
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import { isFunction, isObject } from 'lodash-es';

export function inputAutocompleteDirective() {
    return {
        template: `
            <md-autocomplete flex
                             ng-required="required"
                             ng-disabled="disabled"
                             md-input-name="{{ name }}"
                             md-min-length="0"
                             md-no-cache="true"
                             md-selected-item="selectedItem"
                             md-search-text="searchText"
                             md-items="item in search(searchText)"
                             md-floating-label="{{ label }}">

                <md-item-template>
                    <span md-highlight-text="searchText" ng-if="item.label">
                        {{ item.label }}
                    </span>

                    <span md-highlight-text="searchText" ng-if="!item.label">
                        {{ item }}
                    </span>
                </md-item-template>
                <div class="hint" ng-show="hint" ng-if="!form[name].$invalid">
                    {{ hint }}
                </div>

                <div ng-if="form && name" ng-messages="form[name].$error">
                    <div ng-message="required">Required</div>
                    <div ng-message="custom">{{ form[name].customError }}</div>
                    <div ng-repeat="(key, message) in errorMessages" ng-message="{{ key }}">{{ message }}</div>
                </div>
            </md-autocomplete>
        `,
        scope: {
            disabled: '=ngDisabled',
            errorMessages: '=errorMessages',
            filter: '&?filter',
            form: '=form',
            items: '=items',
            label: '@label',
            name: '@name',
            required: '=?required',
            searchText: '=?searchText',
            value: '=value',
            hint: '@?hint',
        },
        link: function(scope, element, attrs) {
            element.addClass('app-form-field');

            scope.search = search;

            // If it's undefined on the scope, it may mean that the attribute is there but
            // without content. If the attribute isn't undefined then we know it's been added.
            if (scope.required === undefined && attrs.required !== undefined) {
                scope.required = true;
            }
            scope.$watch('selectedItem', _updateValue);
            scope.$watch('searchText', _updateValue);
            scope.$watch('value', _valueWatcher);

            function _updateValue() {
                const selectedItem = scope.selectedItem;
                const searchText = scope.searchText;

                if (selectedItem) {
                    if (isObject(selectedItem)) {
                        scope.value = selectedItem.value;
                    } else {
                        scope.value = selectedItem;
                    }
                } else {
                    scope.value = searchText;
                }
            }

            function _valueWatcher(value) {
                if (value && value.length && !scope.searchText) {
                    if (isObject(value)) {
                        scope.searchText = value.label;
                    } else {
                        scope.searchText = value;
                    }
                }
            }

            function search(query) {
                if (isFunction(scope.filter)) {
                    const response = scope.filter({
                        query: query,
                        items: scope.items,
                    });

                    return Promise.resolve(response);
                }

                return scope.items;
            }
        },
    };
}
